export const storeItem = (key: string, stringified: string) => {
  window.localStorage.setItem(btoa(key), btoa(stringified))
}

export const getStoredItem = (key: string): string => {
  const item = window.localStorage.getItem(btoa(key))

  if (!item) return ""
  return atob(item)
}

export const removeStoredItem = (key: string) => {
  window.localStorage.removeItem(btoa(key))
}
